import {useContext, useState} from "react";

import app from "../../firebase";
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import UserContext from "../../components/UserContext";
import {Navigate} from "react-router-dom";
import { toast } from 'react-toastify';
// import

const auth = getAuth(app);

function Login() {
    const [email, setEmail] = useState('');
    const [pass, setPass] = useState('');

    const user = useContext(UserContext);


    if (user) {
        return <Navigate to={'/manager'} />
    }

    function handleSubmit() {

        // Try sign in, otherwise create user
        signInWithEmailAndPassword(auth, email, pass)
                .catch((error) => {
                // if (error.code === 'auth/user-not-found') {
                //     createUserWithEmailAndPassword(auth, email, pass)
                //         .catch((error) => {
                //             toast(`Authentication Error: ${error.code}`);
                //         })
                // } else {
                    toast(`Authentication Error: ${error.code}`);
                // }
            });
    }


    return (
        <section className={"w-screen h-screen bg-blue-50 pt-32"}>
        <div className={"sm:w-1/3 sm:mx-auto mx-4 my-8 rounded bg-white shadow py-8 px-4"}>
            <h1 className={"text-2xl font-bold text-blue-950"}>Login to Paper Pilot</h1>
            <form className={"mt-8"}>
                <div className="mt-4 flex flex-wrap">
                    <label htmlFor="email" className={"text-sm"}>Email:</label>
                    <input
                        type="text"
                        id="email"
                        autoComplete={"email"}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className={"w-full mt-1 border rounded outline-none pl-2 py-1"}
                        // placeholder={"email"}
                    />
                </div>

                <div className="mt-4 flex flex-wrap">
                    <label htmlFor="password" className={"text-sm"}>Password:</label>
                    <input
                        type="password"
                        id="password"
                        autoComplete={"current-password"}
                        value={pass}
                        onChange={(e) => setPass(e.target.value)}
                        className={"w-full mt-1 border rounded outline-none pl-2 py-1"}
                        // placeholder={"password"}
                    />
                </div>

                <button
                    className="px-4 py-2 rounded-md bg-blue-700 text-blue-50 hover:underline active:opacity-75 mt-8"
                    type="submit"
                    onClick={(e) => {
                        e.preventDefault();
                        handleSubmit();
                    }}
                >Login</button>
            </form>
        </div>
        </section>
    )
}

export default Login;